module.exports = __webpack_public_path__ + "img/car_00048.c3d789a4.jpg";